import { createPortal } from 'react-dom';
import { IoMdClose } from 'react-icons/io';

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  closeOnOverlayClick: boolean;
  title?: string;
};

export default function Modal({
  children,
  closeOnOverlayClick,
  onClose,
  title,
}: Props) {
  return createPortal(
    <div
      onClick={() => (closeOnOverlayClick ? onClose() : null)}
      className={`fixed top-0 left-0 z-30 flex h-full w-full items-center justify-center bg-gray-900/40 dark:bg-gray-900/90`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md rounded-lg border bg-white px-9 pt-8 pb-6 shadow-md dark:border-gray-700 dark:bg-gray-900 dark:shadow-gray-700"
      >
        <IoMdClose
          onClick={() => onClose()}
          className="absolute top-2 right-2 h-7 w-7 rounded-md p-1 hover:cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
        />

        <h1 className="text-3xl font-bold mb-3">{title}</h1>

        {children}
      </div>
    </div>,
    document.body
  );
}
